export default __webpack_public_path__ + "static/media/4-2_image25@2x.a1d76c4b.png";